/**
 * Agile – Variant Media Filter
 * Gallery + Zoom Dialog + Mobile Dots Hint (anti-flicker)
 */
document.addEventListener('DOMContentLoaded', () => {
  /* =========================
     UTILITIES
  ========================= */
  const normalize = (str) =>
    (str || '').toLowerCase().trim().replace(/\s+/g, ' ');

  const matchColor = (alt, color) => {
    alt = normalize(alt);
    color = normalize(color);
    if (!alt || !color) return false;

    return (
      alt === color ||
      alt.startsWith(color + ' ') ||
      alt.endsWith(' ' + color) ||
      alt.includes(' ' + color + ' ')
    );
  };

  const getSelectedColorRadio = () => {
    const checked = [
      ...document.querySelectorAll('.variant-picker input[type="radio"]:checked'),
    ];

    return (
      checked.find((i) =>
        /(^|[^a-z])(color|colore|colour|couleur)([^a-z]|$)/i.test(i.name)
      ) || checked[0]
    );
  };

  /* =========================
     GALLERY – PAGINA PRODOTTO
  ========================= */
  const filterMainGallery = (color) => {
    const items = document.querySelectorAll(
      'media-gallery .product-media-container'
    );
    if (!items.length) return;

    let found = false;

    items.forEach((item) => {
      const img = item.querySelector('img');
      if (!img) return;

      const ok = matchColor(img.alt, color);
      item.style.display = ok ? '' : 'none';
      if (ok) found = true;
    });

    // fallback sicurezza
    if (!found) {
      items.forEach((i) => (i.style.display = ''));
    }
  };

  /* =========================
     ZOOM DIALOG
  ========================= */
  const filterZoomDialog = (color) => {
  const dialog = document.querySelector('zoom-dialog dialog');
  if (!dialog) return;

  const thumbs = dialog.querySelectorAll('.dialog-thumbnails-list__thumbnail');
  const slides = dialog.querySelectorAll(
    '.dialog-zoomed-gallery .product-media-container'
  );

  if (!thumbs.length || !slides.length) return;

  thumbs.forEach((btn, index) => {
    const img = btn.querySelector('img');
    const slide = slides[index];
    if (!img || !slide) return;

    const ok = matchColor(img.alt, color);

    /* === SLIDE === */
    slide.style.display = ok ? '' : 'none';

    /* === THUMB: SOLO STATO VISIVO === */
    if (ok) {
      btn.style.opacity = '1';
      btn.style.filter = 'none';
    } else {
      btn.style.opacity = '0';
      btn.style.filter = 'grayscale(100%)';
    }
  });
};

  /* =========================
     MOBILE DOTS – HINT (NO FLICKER)
  ========================= */
const updateMobileDots = () => {
  const dotsWrapper = document.querySelector('.slideshow-controls__dots');
  if (!dotsWrapper) return;

  const dots = Array.from(dotsWrapper.children);
  if (!dots.length) return;

  dotsWrapper.style.visibility = 'hidden';

  dots.forEach((dot) => {
    dot.style.display = 'none';
    dot.removeAttribute('aria-selected');
  });

  const visibleDots = dots.slice(0, 4);
  visibleDots.forEach((dot) => {
    dot.style.display = '';
  });

  // stato fisso = hint
  if (visibleDots[0]) {
    visibleDots[0].setAttribute('aria-selected', 'true');
  }

  requestAnimationFrame(() => {
    dotsWrapper.style.visibility = '';
  });
};


  /* =========================
     APPLY (CENTRALIZZATO)
  ========================= */
  const applyAll = () => {
    const selected = getSelectedColorRadio();
    if (!selected) return;

    const color = normalize(selected.value);

    filterMainGallery(color);
    filterZoomDialog(color);

    // Dots dopo che Horizon ha finito
    requestAnimationFrame(updateMobileDots);
  };

  /* =========================
     INIT & EVENTS
  ========================= */
  applyAll();

  document.addEventListener('change', (e) => {
    if (e.target.matches('.variant-picker input[type="radio"]')) {
      applyAll();
    }
  });

  // Horizon rerender / zoom / AJAX
  const observer = new MutationObserver(() => {
    applyAll();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  
});

/* =========================================================
   CARD SWATCHES – SAFE PREVIEW
========================================================= */

document.addEventListener('mouseover', function (e) {
  var swatch = e.target.closest('.card-swatch');
  if (!swatch) return;

  var card = swatch.closest('.card, .product-card, .card-product');
  if (!card) return;

  var img = card.querySelector('img');
  if (!img) return;

  var newSrc = swatch.getAttribute('data-image');
  if (!newSrc) return;

  if (!img.dataset.originalSrc) {
    img.dataset.originalSrc = img.src;
  }

  img.src = newSrc;
});

document.addEventListener('mouseout', function (e) {
  var swatch = e.target.closest('.card-swatch');
  if (!swatch) return;

  var card = swatch.closest('.card, .product-card, .card-product');
  if (!card) return;

  var img = card.querySelector('img');
  if (!img || !img.dataset.originalSrc) return;

  img.src = img.dataset.originalSrc;
});